module.exports = __webpack_public_path__ + "static/img/loyo-medal-3.795e542e.png";